import { MapLatLng } from "./map.latlng";

export class HeatMap {
    public id: number;       // Identificador secuencial
    public map: any;         // Mapa nativo
    public heatMap: any;     // Mapa de calor nativo
    public points: MapLatLng[];

    constructor(id: number, map: any, points: MapLatLng[]) {
        this.id = id;
        this.map = map;
        this.points = points;
    }
}
